import { IAutocomplete, IFieldType, IFormFields } from "shared/types";
import { copy } from "shared/assets";

const { companyProperties, errors } = copy;
const addressCopy = companyProperties.billingAddress.properties;

export const fields: IFormFields = [
  {
    name: "name",
    label: companyProperties.name.title,
    type: IFieldType.text,
    validation: {
      required: errors.required,
    },
  },
  {
    name: "billingAddress",
    style: { gridTemplateColumns: "1fr 1fr" },
    hideContainer: true,
    fields: [
      {
        name: "addressLine1",
        label: addressCopy.addressLine1.title,
        type: IFieldType.text,
        autocomplete: IAutocomplete.addressLine1,
        validation: {
          required: errors.required,
        },
        note: addressCopy.addressLine1.note,
      },
      {
        name: "addressLine2",
        label: addressCopy.addressLine2.title,
        autocomplete: IAutocomplete.addressLine2,
        type: IFieldType.text,
        note: addressCopy.addressLine2.note,
      },
      {
        name: "city",
        label: addressCopy.city.title,
        type: IFieldType.text,
        validation: {
          required: errors.required,
        },
      },
      {
        name: "zip",
        label: addressCopy.zip.title,
        type: IFieldType.text,
        autocomplete: IAutocomplete.postalCode,
        validation: {
          required: errors.required,
        },
      },
      {
        name: "state",
        label: addressCopy.state.title,
        type: IFieldType.text,
      },
      {
        name: "country",
        label: addressCopy.country.title,
        type: IFieldType.country,
        autocomplete: IAutocomplete.country,
        validation: {
          required: errors.required,
        },
      },
    ],
  },
  {
    name: "vat",
    label: companyProperties.vatNumber.title,
    type: IFieldType.vat,
    note: companyProperties.vatNumber.note,
  },
];
